/* dl-shuffle.js — design—light · „Překvapte mě" on the brand rail (2026-08-13)

   WHAT IT DOES
   Adds a „Překvapte mě" button to the „Od stejného výrobce" rail on the PDP.
   Each click swaps the tiles for a fresh random draw from the SAME brand
   collection, so the rail stops being the same twelve products forever.

   WHY IT TOUCHES NO LIQUID
   sections/dl-product-main.liquid is 29 KB and owns the whole buy box. Editing
   it to add one button would put the price, the variant payload and the add-to-
   cart form on the diff for a merchandising nicety. Everything this script needs
   is already in the rendered rail:

     .side                       the brand rail band (the „Hodí se k tomu"
                                 rail has no .side, so it is never touched)
     .side header.sec a.all      href = the brand collection URL,
                                 text  = „Vše od Artemide · 89"  → the count
     .side .grid[data-dl-rail]   the tile grid; its child count = tiles to show
     location.pathname           the product being viewed, to exclude it

   Remove this file from snippets/dl-assets.liquid and the rail is byte-for-byte
   what it was before. That is the whole rollback.

   WHERE THE TILES COME FROM
   sections/dl-rail-shuffle.liquid, fetched through the Section Rendering API:
       /collections/<brand>?section_id=dl-rail-shuffle&page=<n>
   It renders tiles with the same dl-product-card snippet the rail itself uses,
   so a shuffled tile is identical to a server-rendered one — badges, brandmark,
   price chip, „na dotaz". There is no second card implementation to keep in sync.

   PER = 24 must match `by` in that section.

   TWO THINGS LEARNED THE HARD WAY, BOTH GUARDED BELOW
   1. products_count and what the storefront actually paginates DISAGREE.
      Artemide reads 153 in the admin and 89 on the storefront (drafts, market
      restrictions). 89/24 = 4 real pages. A page past the end returns an EMPTY
      fragment, not an error — see the empty-response retry in attempt().
   2. Responses are parsed with DOMParser, which builds an INERT document: the
      24 tiles in a fetched page cost no image requests. Only the ~12 written
      into the live grid ever load a photo.

   A failed fetch leaves the rail exactly as it was. This is real merchandising,
   not decoration — it must never blank.
*/
(function () {
  "use strict";

  var PER = 24;                       /* must match `by` in dl-rail-shuffle.liquid */
  var SECTION = "dl-rail-shuffle";
  var LABEL = "Překvapte mě";

  if (!window.fetch || !window.Promise || !window.DOMParser) return;

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  function shuffle(a) {               /* Fisher–Yates */
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  function path(u) {                  /* href → pathname, no query, no origin */
    if (!u) return "";
    try { return new URL(u, location.origin).pathname; } catch (e) { return u.split("?")[0]; }
  }

  function init(side) {
    var head = side.querySelector("header.sec");
    var grid = side.querySelector(".grid[data-dl-rail]");
    var all = head && head.querySelector("a.all");
    if (!head || !grid || !all) return;

    var src = path(all.getAttribute("href"));
    var show = grid.children.length;
    var skip = location.pathname;
    if (!src || src.indexOf("/collections/") === -1 || show < 2) return;

    /* „Vše od Artemide · 89" — the storefront-visible count, which is the one
       that matches how the collection paginates. Missing → guess one page and
       let the first response correct it. */
    var count = 0;
    var m = (all.textContent || "").replace(/\s| /g, "").match(/·(\d+)/);
    if (m) count = parseInt(m[1], 10) || 0;

    /* Nothing to circulate: every product the brand has is already on screen. */
    if (count && count <= show + 1) return;

    var pages = null;                 /* page count in use */
    var pagesKnown = false;           /* true once a response has stated it */
    var cache = {};                   /* page -> array of tile HTML strings */
    var lastPage = null;
    var preferred = null;             /* page warmed on hover, spent on next click */
    var firstTile = null;             /* guards against a click that changes nothing */
    var busy = false;

    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "surp";
    btn.setAttribute("data-dl-shuffle", "");
    /* Same construction as the homepage „Překvapte mě" block in
       sections/dl-bestsellers.liquid — label, then the glyph in a <b> — so the
       two buttons are the same object in two places. The glyph is ↻ (reload),
       not the → the homepage uses: this one re-draws the rail, it does not
       navigate anywhere, and an arrow that promises a page change would lie. */
    btn.appendChild(document.createTextNode(LABEL));
    var ic = document.createElement("b");
    ic.className = "ic";
    ic.setAttribute("aria-hidden", "true");
    ic.textContent = "↻";
    btn.appendChild(ic);
    head.insertBefore(btn, all);

    function guessPages() {
      return pages || Math.max(1, Math.ceil((count || PER) / PER));
    }

    function pick() {
      if (preferred && preferred !== lastPage) { var q = preferred; preferred = null; return q; }
      var P = guessPages();
      if (P < 2) return 1;
      var p = 1 + Math.floor(Math.random() * P);
      if (p === lastPage) p = (p % P) + 1;      /* never the same page twice running */
      return p;
    }

    function fetchPage(p) {
      if (cache[p]) return Promise.resolve(cache[p]);
      var url = src + "?section_id=" + SECTION + "&page=" + p;
      return fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } })
        .then(function (r) {
          if (!r.ok) throw new Error("HTTP " + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var frag = doc.querySelector("[data-dl-shuffle-page]");
          var n = frag ? parseInt(frag.getAttribute("data-pages"), 10) : 0;
          if (n > 0) { pages = n; pagesKnown = true; }
          var tiles = [];
          Array.prototype.forEach.call(doc.querySelectorAll("a.pcard"), function (c) {
            if (path(c.getAttribute("href")) === skip) return;   /* not the product being viewed */
            tiles.push(c.outerHTML);
          });
          cache[p] = tiles;
          return tiles;
        });
    }

    function render(tiles) {
      var deck = shuffle(tiles.slice()).slice(0, show);
      /* A brand with barely more than a railful can hand back the same opening
         tile twice; one swap is enough for the click to visibly do something. */
      if (deck.length > 1 && deck[0] === firstTile) {
        var t = deck[0]; deck[0] = deck[deck.length - 1]; deck[deck.length - 1] = t;
      }
      firstTile = deck[0];
      grid.innerHTML = deck.join("");
      /* dl-rail.js owns the full-last-row trim. Re-run it on the new tiles;
         the resize path is the fallback if this file ever loads without it. */
      if (window.dlRail && window.dlRail.refresh) window.dlRail.refresh();
      else window.dispatchEvent(new Event("resize"));
    }

    /* One retry, and it goes to page 1 rather than another random draw: page 1 is
       the only page guaranteed to exist, so the click still changes the rail.
       Shopify answers an out-of-range page with either an empty fragment or a
       404 — both land here. pagesKnown guards the correction: when the response
       stated data-pages, that number is the truth and must not be overwritten
       by a guess derived from the page we happened to ask for. */
    function shrink(p) { if (!pagesKnown) pages = Math.max(1, p - 1); }

    function attempt(p, retried) {
      return fetchPage(p).then(function (tiles) {
        if (tiles.length) { lastPage = p; render(tiles); return; }
        if (retried) return;                    /* still nothing: leave the rail alone */
        shrink(p);
        return attempt(1, true);
      }, function (err) {
        if (retried || p === 1) throw err;      /* a real outage, not a bad page number */
        shrink(p);
        return attempt(1, true);
      });
    }

    function done() {
      busy = false;
      btn.disabled = false;
      btn.classList.remove("busy");
      btn.removeAttribute("aria-busy");
    }

    btn.addEventListener("click", function () {
      if (busy) return;
      busy = true;
      btn.disabled = true;
      btn.classList.add("busy");
      btn.setAttribute("aria-busy", "true");
      attempt(pick(), false)["catch"](function (e) {
        try { console.warn("dl-shuffle:", e && e.message ? e.message : e); } catch (_) {}
      })["then"](done, done);
    });

    /* Warm one page on hover/focus so the first click lands with no wait. */
    var warmed = false;
    function warm() {
      if (warmed) return;
      warmed = true;
      var p = pick();
      preferred = p;
      fetchPage(p)["catch"](function () { preferred = null; });
    }
    btn.addEventListener("pointerenter", warm);
    btn.addEventListener("focus", warm);
  }

  ready(function () {
    Array.prototype.forEach.call(document.querySelectorAll(".dl-scope .side"), init);
  });
})();
